import { getApiUrl } from '../config/api';

export const LOCATION_PERMISSION_KEY = 'ubsaapp_location_permission';

export const getLocationPermissionPreference = () => {
  try {
    return localStorage.getItem(LOCATION_PERMISSION_KEY);
  } catch {
    return null;
  }
};

export const setLocationPermissionPreference = (value) => {
  try {
    if (value) {
      localStorage.setItem(LOCATION_PERMISSION_KEY, value);
    } else {
      localStorage.removeItem(LOCATION_PERMISSION_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const getSiteHostname = () => {
  if (typeof window === 'undefined') return 'this site';
  return window.location.hostname.replace(/^www\./i, '') || 'this site';
};

export const getBrowserCoordinates = () =>
  new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('Geolocation is not supported on this device.'));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        if (error?.code === 1) {
          reject(new Error('Location permission was denied.'));
          return;
        }
        if (error?.code === 2) {
          reject(new Error('Unable to detect your location right now.'));
          return;
        }
        if (error?.code === 3) {
          reject(new Error('Location request timed out. Please try again.'));
          return;
        }
        reject(new Error('Could not access your location.'));
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 60000,
      }
    );
  });

export const reverseGeocodeCoords = async (latitude, longitude) => {
  const url = getApiUrl(
    `/api/geocode/reverse?lat=${encodeURIComponent(latitude)}&lon=${encodeURIComponent(longitude)}`
  );
  const response = await fetch(url);
  const json = await response.json().catch(() => ({}));

  if (!response.ok || !json?.success) {
    throw new Error(json?.message || 'Could not resolve your location.');
  }

  return json;
};

export const formatNearbyLocationLabel = (result) => {
  if (!result) return 'Nearby';

  const city = String(result.city || '').trim();
  const country = String(result.country || '').trim();

  if (city && country && city.toLowerCase() !== country.toLowerCase()) {
    return `${city}, ${country}`;
  }

  if (city) return city;

  const displayName = String(result.displayName || '').trim();
  if (displayName) {
    return displayName.split(',')[0].trim() || 'Nearby';
  }

  return 'Nearby';
};

export const resolveNearbyLocationLabel = async () => {
  const coords = await getBrowserCoordinates();
  const place = await reverseGeocodeCoords(coords.latitude, coords.longitude);
  return formatNearbyLocationLabel(place);
};
